import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Card,
  CardContent,
  CardDescription,
  // CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AuthLogin } from "@/components/blocks/auth-login";
import { AuthSignup } from "@/components/blocks/auth-signup";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/providers/auth-provider";
import { toast } from "@/hooks/use-toast";

export function AuthForm() {
  const { login, signup } = useAuth();
  const navigate = useNavigate();

  async function onLogin(email: string, password: string) {
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    try {
      await login({
        email: email,
        password: password,
      });
      toast({
        title: "Login Successful:",
        description: "User Login is success.",
      });
      navigate("/main");
    } catch (err: any) {
      toast({
        title: "Login Failed:",
        description: err.message,
      });
      console.log(err);
    }
  }

  async function onRegister(name: string, email: string, password: string) {
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    try {
      await signup({
        name: name,
        email: email,
        password: password,
      });
      toast({
        title: "Signup Successful:",
        description: "User Signup is success.",
      });
      navigate("/main");
    } catch (err: any) {
      toast({
        title: "Signup Failed:",
        description: err.message,
      });
      console.log(err);
    }
  }

  function onGuestLogin(setValue: any) {
    setValue("email", "test01@uzoo.in");
    setValue("password", "xptmxmdkdlel");
  }

  const handlerGuestButton =
    process.env.NODE_ENV === "production" ? null : onGuestLogin;

  return (
    <Tabs defaultValue="login" className="w-[400px]">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="login">Log in</TabsTrigger>
        <TabsTrigger value="signup">Sign Up</TabsTrigger>
      </TabsList>
      <TabsContent value="login">
        <Card>
          <CardHeader>
            <CardTitle>Log in</CardTitle>
            <CardDescription>
              Enter your email address and password below to login to your
              account. {process.env.NODE_ENV}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-2">
            <AuthLogin onLogin={onLogin} onGuestLogin={handlerGuestButton} />
          </CardContent>
          {/* <CardFooter></CardFooter> */}
        </Card>
      </TabsContent>
      <TabsContent value="signup">
        <Card>
          <CardHeader>
            <CardTitle>Sign up</CardTitle>
            <CardDescription>
              Fill in your details below to create a new account.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-2">
            <AuthSignup onRegister={onRegister} />
          </CardContent>
          {/* <CardFooter></CardFooter> */}
        </Card>
      </TabsContent>
    </Tabs>
  );
}
